import React, { useEffect, useState } from "react";
import Select, { ActionMeta } from "react-select";
import {
    Stack,
    Card,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import { Globals } from "../../helpers/globals";
import { DataService } from "../../services/DataService";
import * as APIModels from "../../models/";
import { log } from "console";

type PortalSelectorProps = {
    /**
     * Additional MUI-specific styles to apply to the AppBar.
     */
    sx?: any;
    attorney?: APIModels.Attorney;
};

type OptionType = { label: string; value: string };

export default function PortalSelector(params: PortalSelectorProps) {
    const [final_sx, _] = React.useState({
        ...(params.sx ?? {}),
        width: params.sx.width ?? "100%",
        paddingY: params.sx.paddingY ?? "3rem",
        paddingX: params.sx.paddingX ?? "3rem",
    });
    React.useEffect(() => {
        Globals.retrieveMe();
    }, []);
    const [portlUrl, setportlUrl] = useState<string>();
    const [portalOptions, setportalOptions] = useState<OptionType[]>([]);
    const [stateOptions, setStateOptions] = useState<OptionType[]>(
        [] as OptionType[]
    );
    const [buttonPortal, setButtonPortal] = useState<string>("");

    useEffect(() => {
        DataService.getStates().then(
            (resp) => {
                const options = resp
                    .filter((v, _) => {
                        return v.portal !== null && v.portal !== undefined;
                    })
                    .map((v, _) => {
                        return { value: v.portal!, label: v.abbreviation! };
                    });
                setStateOptions(options);
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    const filterOption = (option: OptionType, inputValue: string): boolean =>
        (
            option.label
                .toString()
                .toLowerCase()
                .match(inputValue.toLowerCase()) || []
        ).length > 0;

    const currentUser = Globals.currentUserValue;
    const onPortalChange = (
        value: OptionType | null,
        _: ActionMeta<OptionType>
    ) => {
        setportlUrl(value?.value);
    };
    const onPortalChangeAttorney = (
        value: OptionType | null,
        _: ActionMeta<OptionType>
    ) => {
        setportalOptions([]);
        setButtonPortal(value?.value ?? "");
    };

    const onStateChange = (
        value: OptionType | null,
        _: ActionMeta<OptionType>
    ) => {
        console.log({ ...value });
        if (value?.value.includes(", ")) {
            const portalUrls = value?.value.split(", ");
            setportalOptions(
                portalUrls.map<OptionType>((portal) => {
                    return { value: portal, label: portal };
                })
            );
        } else {
            setportalOptions([]);
            setportlUrl(value?.value ?? "");
        }
    };

    useEffect(() => {
        if (portlUrl && portlUrl !== "") {
            window.open(portlUrl, "_blank");
        }
    }, [portlUrl]);

    useEffect(() => {
        const stateOption = stateOptions.find((stateOption) => {
            return stateOption.label == params.attorney?.state;
        });
        console.log({ stateOption: stateOption });
        if (stateOption?.value.includes(", ")) {
            const portalUrls = stateOption?.value.split(", ");
            setportalOptions(
                portalUrls.map<OptionType>((portal) => {
                    return { value: portal, label: portal };
                })
            );
        } else {
            setportalOptions([]);
            setButtonPortal(stateOption?.value ?? "");
        }
    }, [params?.attorney, stateOptions]);

    useEffect(() => {
        console.log({
            attorneyState: params.attorney?.state,
            portalOptions: portalOptions,
            buttonPortal: buttonPortal,
        });
    }, [params?.attorney?.state, portalOptions, buttonPortal]);

    if (params.attorney === null || params.attorney === undefined) {
        return currentUser.role!.key! >= 500 || currentUser.role!.key! == 60 ? (
            <Card style={{ ...final_sx, padding: "0.5rem 2rem 2rem 2rem" }}>
                <Stack direction="column" justifyContent="left" width={"100%"}>
                    <Stack direction="row" justifyContent="left" width={"100%"}>
                        <h3>Go to a State Filing Portal</h3>
                    </Stack>
                    <Stack
                        direction="row"
                        justifyContent="left"
                        width={"100%"}
                        spacing="1rem"
                    >
                        <Select
                            className="col-4 basic-single"
                            style={{
                                zIndex: 11,
                            }}
                            id="selState"
                            name="selState"
                            value={stateOptions.filter(
                                (c) => c.value === portlUrl
                            )}
                            filterOption={filterOption}
                            options={stateOptions}
                            onChange={onStateChange}
                        />
                        {portalOptions.length > 0 ? (
                            <Select
                                className="col-4"
                                style={{
                                    zIndex: 11,
                                }}
                                id="selPortal"
                                name="selPortal"
                                value={portalOptions.filter(
                                    (c) => c.value === portlUrl
                                )}
                                filterOption={filterOption}
                                options={portalOptions}
                                onChange={onPortalChange}
                            />
                        ) : (
                            <></>
                        )}
                    </Stack>
                </Stack>
            </Card>
        ) : (
            <></>
        );
    } else {
        if (currentUser.role!.key! >= 500 || currentUser.role!.key! == 60) {
            if (buttonPortal === "" && portalOptions.length === 0) {
                return <> </>;
            } else if (buttonPortal === "" && portalOptions.length >= 0) {
                return (
                    <Card
                        className="card"
                        style={{
                            ...final_sx,
                            padding: "0.5rem 2rem 2rem 2rem",
                        }}
                    >
                        <Stack
                            direction="column"
                            justifyContent="left"
                            width={"100%"}
                        >
                            <Stack
                                direction="row"
                                justifyContent="left"
                                width={"100%"}
                            >
                                <h3>Go to a State Filing Portal</h3>
                            </Stack>
                            <Stack
                                direction="row"
                                justifyContent="left"
                                width={"100%"}
                                spacing="1rem"
                            >
                                <Select
                                    className="col-3"
                                    style={{
                                        zIndex: 11,
                                    }}
                                    id="selPortal"
                                    name="selPortal"
                                    value={portalOptions.filter(
                                        (c) => c.value === portlUrl
                                    )}
                                    filterOption={filterOption}
                                    options={portalOptions}
                                    onChange={onPortalChangeAttorney}
                                />
                                <Stack
                                    direction="column"
                                    justifyContent="center"
                                    width={"33%"}
                                    spacing="1rem"
                                >
                                    <ul>
                                        <li>
                                            <b>GA: </b> Go to PeachCort
                                        </li>
                                        <li>
                                            <b>GO: </b> Go to Tyler
                                        </li>
                                    </ul>
                                </Stack>
                            </Stack>
                        </Stack>
                    </Card>
                );
            } else if (buttonPortal !== "") {
                return (
                    <Card
                        className="card"
                        style={{
                            ...final_sx,
                            padding: "0.5rem 2rem 2rem 2rem",
                        }}
                    >
                        <Stack
                            direction="column"
                            justifyContent="left"
                            width={"100%"}
                        >
                            <Stack
                                direction="row"
                                justifyContent="left"
                                width={"100%"}
                            >
                                <h3>Go to a State Filing Portal</h3>
                            </Stack>
                            <Stack
                                direction="row"
                                justifyContent="left"
                                width={"100%"}
                                spacing="1rem"
                            >
                                <a
                                    className="btn btn-primary"
                                    href={buttonPortal}
                                    target="_blank"
                                >
                                    Go to Portal
                                </a>
                            </Stack>
                        </Stack>
                    </Card>
                );
            } else {
                return <> </>;
            }
        } else {
            return <> </>;
        }
    }
}
